import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { IoCloseOutline } from "react-icons/io5";
import socialIcon from "../Image/Social-icons1.png";
import emailIcon from "../Image/email-icon.png";
import passIcon from "../Image/pass-icon.png";
import flagIcon from "../Image/flag-icon.png";
import ticketIcon from "../Image/ticket-icon.png";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import Login from "./Login";
import { toast } from "react-toastify";
import { GiWallet } from "react-icons/gi";

function Signup({ onClose, setIsAuth }) {
  const [activeTab, setActiveTab] = useState("signup");
  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log("data", data);
    const storedData = JSON.parse(localStorage.getItem("user"));
    const users = Array.isArray(storedData) ? storedData : [];
    const emailExists = users.find((user) => user.email === data.email);
    if (emailExists) {
      toast.error("Email already exists");
      return;
    }
    const updatedUser = {...data,wallet: parseFloat(data.wallet) || 0,};

    const updatedData = [...users, updatedUser];

    localStorage.setItem("user", JSON.stringify(updatedData));
    toast.success("Signup successful");

    onClose();
  };

  useEffect(() => {
    const user = localStorage.getItem("loggedUser");
    if (user) {
    }
  }, []);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="signup-box" onClick={(e) => e.stopPropagation()}>
        <div className="signup-header">
          <button
            className={`btn-tab login ${activeTab === "login" ? "active" : ""}`}
            onClick={() => setActiveTab("login")}
          >
            Login
          </button>

          <button
            className={`btn-tab signup ${activeTab === "signup" ? "active" : ""}`}
            onClick={() => setActiveTab("signup")}
          >
            Signup
          </button>
          <IoCloseOutline className="close-btn" onClick={onClose} />
        </div>

        {activeTab === "signup" ? (
          <form onSubmit={handleSubmit(onSubmit)} className="signup-form">
            <div className="d-flex align-items-start gap-3 form-row">
              <div className="form-field">
                <div className="d-flex align-items-center gap-2 input-group">
                  <img src={emailIcon} alt="icon" />
                  <input
                    type="email"
                    placeholder="Enter your email"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^\S+@\S+$/i,
                        message: "Invalid email",
                      },
                    })}
                  />
                </div>
                {errors.email && (
                  <p className="error">{errors.email.message}</p>
                )}
              </div>

              <div className="form-field">
                <div className="d-flex align-items-center gap-2 input-group">
                  <img src={passIcon} alt="icon" />
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter your password"
                    {...register("password", {
                      required: "Password is required",
                      pattern: {
                        value:
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                        message:
                          "Password must contain uppercase, lowercase, number, and special character",
                      },
                    })}
                  />

                  <span
                    className="eye"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                  </span>
                </div>
                {errors.password && (
                  <p className="error">{errors.password.message}</p>
                )}
              </div>
            </div>

            <div className="d-flex align-items-start gap-3 form-row">
              <div className="form-field">
                <div className="d-flex align-items-center gap-2 input-group">
                  <img src={flagIcon} alt="icon" />
                  <select
                    {...register("country", {
                      required: "Country is required",
                    })}
                  >
                    <option value="">Choose country of residence</option>
                    <option value="India">India</option>
                    <option value="USA">United States</option>
                    <option value="UK">United Kingdom</option>
                    <option value="Canada">Canada</option>
                  </select>
                </div>
                {errors.country && (
                  <p className="error">{errors.country.message}</p>
                )}
              </div>

              <div className="form-field">
                <div className="d-flex align-items-center gap-2 input-group">
                  <img src={ticketIcon} alt="icon" />
                  <input
                    type="text"
                    placeholder="Promo code (optional)"
                    {...register("promo", {
                      required: "Promo code is required",
                    })}
                  />
                </div>
                {errors.promo && (
                  <p className="error">{errors.promo.message}</p>
                )}
              </div>
            </div>

            <div className="form-field">
              <div className="d-flex align-items-center gap-2 input-group">
                <GiWallet className="wallet-icon" />
                <input
                  type="text"
                  placeholder="Player Wallet"
                  {...register("wallet")}
                />
              </div>
            </div>

            <div className="form-field mt-4">
              <label className="custom-checkbox">
                <input
                  type="checkbox"
                  {...register("terms", {
                    required: "You must accept terms",
                  })}
                />
                <span className="checkmark"></span>

                <p className="mb-0">
                  I confirm that I am 18 years old and I have read the{" "}
                  <span
                    style={{ color: "#1C53A5", textDecoration: "underline" }}
                  >
                    terms of service
                  </span>
                </p>
              </label>
              {errors.terms && <p className="error">{errors.terms.message}</p>}
            </div>

            <div className="form-field mt-2 email-promo">
              <label className="custom-checkbox">
                <input
                  type="checkbox"
                  {...register("promos", {
                    // required: "You must accept terms",
                  })}
                />
                <span className="checkmark"></span>

                <p className="mb-0">Receive Email Promos</p>
              </label>
              {/* {errors.promos && (
                <p className="error">{errors.promos.message}</p>
              )} */}
            </div>

            <button type="submit" className="create-btn">
              Create Account
            </button>

            <p className="or-text">Or Sign up with</p>

            <div className="social-icons">
              <img src={socialIcon} alt="" />
            </div>

            <p className="login-link">
              Do you have an account?{" "}
              <span onClick={() => setActiveTab("login")}>Login</span>
            </p>
          </form>
        ) : (
          <Login
            setActiveTab={setActiveTab}
            onClose={onClose}
            setIsAuth={setIsAuth}
          />
        )}
      </div>
    </div>
  );
}

export default Signup;
